import React, { useState, useEffect } from 'react';
import testimonials from '../../cms/testimonials.json';
import RichText from './RichText';
import { FaQuoteLeft } from 'react-icons/fa';
import Carousel from './Carousel';
import { TestimonialCardSkeleton } from '../skeleton/SkeletonSystem';
import '../../css/pages/Testimonials.css';

const Testimonials = () => {
  const [loading, setLoading] = useState(true);

  // Simulate loading for demo purposes
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000); // Show skeleton for 1 second

    return () => clearTimeout(timer);
  }, []);

  const renderTestimonialCard = (testimonial) => (
    <div className="testimonial-content">
      <div className="testimonial-image-section">
        {testimonial.image ? (
          <img
            src={testimonial.image}
            alt={testimonial.name}
            className="testimonial-headshot"
            onError={(e) => {
              if (e.target && e.target.style) {
                e.target.style.display = 'none';
              }
              if (e.target && e.target.nextSibling && e.target.nextSibling.style) {
                e.target.nextSibling.style.display = 'flex';
              }
            }}
          />
        ) : null}
        
        {!testimonial.image && (
          <div className="testimonial-initials-fallback">
            {getInitials(testimonial.name)}
          </div>
        )}
      </div>
      
      <div className="testimonial-text-section">
        <FaQuoteLeft className="quote-icon" />
        <RichText value={testimonial.testimonial} className="testimonial-paragraph" />
        <h4 className="testimonial-name">{testimonial.name}</h4>
        {testimonial.student === 'yes' && (
          <p className="testimonial-grad-year">Class of {testimonial.graduationYear}</p>
        )}
        {testimonial.student === 'no' && (
          <p className="testimonial-title">{testimonial.title}</p>
        )}
      </div>
    </div>
  );

  function getInitials(name) {
    return name
      .split(' ')
      .map(word => word[0])
      .join('')
      .toUpperCase();
  }

  if (loading) {
    return (
      <section className="testimonials-section">
        <div className="testimonials-card">
          <TestimonialCardSkeleton />
        </div>
      </section>
    );
  }

  return (
    <section className="testimonials-section">
      <h2 className="section-title">Testimonials</h2>
      <div className="testimonials-card">
        <Carousel
          items={testimonials}
          renderItem={renderTestimonialCard}
          showArrows={true}
          showDots={true}
          itemsPerView={1}
          className="carousel--testimonials"
        />
      </div>
    </section>
  );
};

export default Testimonials; 